<template>
  <CModal
    title="Add product"
    size="lg"
    :show="show"
    @update:show="$emit('close')"
  >
    <CInput
      ref="nameInput"
      label="Product name *"
      v-model="localProduct.name"
      placeholder="e.g. Website design"
      :is-valid="nameValid"
      invalid-feedback="Enter the product or service name"
    />
    <CTextarea
      label="Description"
      placeholder="Shown on the line item"
      rows="4"
      v-model="localProduct.description"
    />
    <CRow>
      <CCol sm="4">
        <CInput
          label="Default price"
          v-model="localProduct.defaultPrice"
          type="number"
          inputmode="decimal"
          min="0"
          step="0.01"
          placeholder="0.00"
        >
          <template #prepend-content>RM</template>
        </CInput>
      </CCol>
      <CCol sm="4">
        <CInput
          label="Default unit"
          v-model="localProduct.defaultUnit"
          placeholder="e.g. pcs, kg, hours"
        />
      </CCol>
      <CCol sm="4">
        <CInput label="Category" v-model="localProduct.category" />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <CInput label="SKU" v-model="localProduct.sku" />
      </CCol>
      <CCol sm="6">
        <CInput label="Barcode" inputmode="numeric" v-model="localProduct.barcode" />
      </CCol>
    </CRow>
    <template #footer>
      <div class="d-flex justify-content-between w-100">
        <CButton color="light" @click="$emit('close')">Cancel</CButton>
        <CButton color="primary" @click="saveProduct">Add product</CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
export default {
  name: "ProductFormModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localProduct: { ...this.product },
      submitted: false,
    };
  },
  watch: {
    product: {
      handler(newProduct) {
        this.localProduct = { ...newProduct };
      },
      deep: true,
    },
    show(newValue) {
      if (newValue) {
        this.localProduct = { ...this.product };
        this.submitted = false;
      }
    },
  },
  computed: {
    isValid() {
      return !!(this.localProduct.name && this.localProduct.name.trim().length > 0);
    },
    nameValid() {
      return this.submitted ? this.isValid : null;
    },
  },
  methods: {
    saveProduct() {
      this.submitted = true;
      if (this.isValid) {
        this.$emit("save", this.localProduct);
        return;
      }
      this.$nextTick(() => {
        const el = this.$refs.nameInput && this.$refs.nameInput.$el.querySelector("input");
        if (el) el.focus();
      });
    },
  },
};
</script>
